import { Link } from 'react-router-dom'

import { NavLinkFooter } from './navLinkFooter'

import waze from '../../assets/waze_icon.png'
import gmaps from '../../assets/gmap_icon.png'
import uber from '../../assets/uber_icon.png'

export function Footer() {
 return (
  <footer className="bg-black h-64 max-[767px]:py-6">
   <div className="container h-full">
    <div className="flex h-full justify-between items-center">
     <div>
      <span className="font-['rns-milesblack'] font-bold text-white text-base">
       Adman
      </span>
      <h2 className="font-['rns-milesregular'] font-bold text-white text-base">
       Av. Nicolas Boer, 399 | 3º andar <br /> São Paulo - SP
      </h2>
      <div className="hidden max-[767px]:block">
       <br />
       <p className="text-white font-normal text-base font-['rns-milesregular']">
        A gente sabe que o seu tempo é precioso.
        <br /> Então escolha qual aplicativo vai trazer você mais
        <br /> rápido até a Adman.
        <br />
        <br />
        <span
         className="flex gap-1"
         role="group"
         aria-label="Links para apps de navegação"
        >
         <Link
          to="waze://?q=Av. Av. Nicolas Boer, 399 - São Paulo - SP 01140-060"
          target="_blank"
          aria-label="Abrir no Waze"
          className="w-[10%]"
         >
          <img src={waze} alt="Waze" />
         </Link>
         <Link
          to="http://maps.google.com/maps?q=Av. Nicolas Boer, 399 - São Paulo - SP 01140-060"
          target="_blank"
          aria-label="Abrir no Google Maps"
          className="w-[10%]"
         >
          <img src={gmaps} alt="Google Maps" />
         </Link>
         <Link
          to="https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[formatted_address]=Avenida%20Nicolas%20Boer,%20399%20-%20Barra%20Funda&dropoff[latitude]=-23.5198029&dropoff[longitude]=-46.682725"
          target="_blank"
          aria-label="Chamar Uber"
          className="w-[10%]"
         >
          <img src={uber} alt="Uber" />
         </Link>
        </span>
       </p>
      </div>
     </div>
     <ul className="hidden min-[768px]:block min-[992px]:flex gap-8">
      <NavLinkFooter link="home" />
      <NavLinkFooter link="soluções" />
      <NavLinkFooter link="trabalhos" />
      <NavLinkFooter link="clientes" />
      <NavLinkFooter link="contato" />
     </ul>
    </div>
   </div>
  </footer>
 )
}
